// extracted by mini-css-extract-plugin
export default {"ldsLoader":"styles_lds-loader__OsOqx","ldsLoaderPrimary":"styles_lds-loader-primary__o8II6","ldsLoaderDark":"styles_lds-loader-dark__u9h6g"};